import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class PsdiService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }
  
  getPsdi(): Observable<any> {
    return this.http.get(this.baseUrl + 'revPsdi', { headers: this.header(this.token) });
  }

  getPsdiActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'revPsdiActivos', { headers: this.header(this.token) });
  }
  
  getPsdiById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'revPsdi/' + id, { headers: this.header(this.token) });
  }

  postPsdi(Psdi: any): Observable<any> {
    return this.http.post(this.baseUrl + 'revPsdi', Psdi, { headers: this.header(this.token) });
  }

  putPsdi(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'revPsdi', bodyString, { headers: this.header(this.token) });
  }

  deletePsdi(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'revPsdi/' + id, { headers: this.header(this.token) });
  }

}
